'use client'

import {
    clearProntuarioOrigin,
    getProntuarioOrigin,
    ProntuarioOrigin,
} from '@/lib/prontuario/prontuario-origin'
import { useEffect, useState } from 'react'
import { MdArrowBack, MdClose } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Botão fixo "Voltar ao prontuário", enquanto houver um fluxo aberto a partir dele.
 *
 * Mora no layout, e não nas telas: agendar a partir do prontuário atravessa
 * agendamento, cobrança, detalhe do atendimento e a guia — telas que não se conhecem.
 * Ensinar cada uma a oferecer a volta seria repetir a regra em quatro lugares e
 * esquecê-la no quinto.
 *
 * Some sozinho quando o operador já ESTÁ no prontuário: ali o botão seria ruído, e
 * continuar mostrando-o é o que faz um atalho parecer resíduo de tela.
 */
export default function ProntuarioReturnButton() {
    const navigate = useNavigate()
    const location = useLocation()
    const [origin, setOrigin] = useState<ProntuarioOrigin | null>(null)

    // Relê a cada navegação: a origem é gravada por outra tela, e sem isto o botão
    // só apareceria depois de um recarregamento.
    useEffect(() => {
        setOrigin(getProntuarioOrigin())
    }, [location.pathname])

    if (!origin) return null
    // Já chegou: dentro do próprio prontuário o atalho não tem para onde levar.
    if (location.pathname.includes('/prontuario')) return null

    const voltar = () => {
        clearProntuarioOrigin()
        setOrigin(null)
        navigate(origin.path)
    }

    const dispensar = () => {
        clearProntuarioOrigin()
        setOrigin(null)
    }

    return (
        <div className="fixed bottom-4 left-1/2 z-40 -translate-x-1/2">
            <div className="flex items-center gap-1 rounded-full border border-base-300 bg-base-100 py-1 pl-1 pr-1 shadow-lg">
                <button
                    type="button"
                    onClick={voltar}
                    className="btn btn-sm btn-ghost gap-2 rounded-full"
                >
                    <MdArrowBack className="text-base" />
                    <span className="max-w-[14rem] truncate">
                        Voltar ao prontuário de {origin.clientName}
                    </span>
                </button>
                {/* Fluxo abandonado: o operador dispensa sem precisar percorrer o
                    caminho de volta só para se livrar do atalho. */}
                <button
                    type="button"
                    onClick={dispensar}
                    className="btn btn-sm btn-ghost btn-circle"
                    aria-label="Dispensar"
                    title="Dispensar"
                >
                    <MdClose className="text-sm" />
                </button>
            </div>
        </div>
    )
}
